<script lang="ts">import { stateUi } from "@infinitro/config";
import { InfoCard } from "@infinitro/info-card";
import "svelte/store";
import PromoGrid from "./promo-grid.svelte";
export let promotions;
$: useAlternative = $stateUi.promotions.promotionsStyle === "alternative";
</script>

<div class="all-promotions">
	{#if useAlternative}
		<InfoCard>
			<PromoGrid {promotions} />
		</InfoCard>
	{:else}
		<PromoGrid {promotions} />
	{/if}
</div>

<style>
	.all-promotions {
    position: relative;
    margin-bottom: 0.5rem;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 1rem
}
</style>
